// noinspection GraphQLUnresolvedReference

import { impresoraFragmentAst } from '../../base/Impresora/fragments/impresoraFragment.ts'
import { gqlAst } from '../../../utils/gql.ts'

/**
 * Área de producción (estación).
 * Los artículos se enrutan a áreas y cada área recibe sus comandas por pantalla de cocina, impresoras o ambas.
 */
export const AreaFragmentAst = /* GraphQL */ gqlAst`
  ${impresoraFragmentAst}

  fragment areasFields on Area {
    _id
    createdAt
    descripcion
    impresoras {
      ...impresoraFields
    }
    modoSalida
    nombre
    orden
    state
    sucursal  {
      codigo
    }
    updatedAt
    usucre
    usumod
  }
`
